import styled, { css } from 'styled-components';

import { colors } from 'common/styles/style-constants';

export const ProfilePhoto = styled.img`
  border-radius: 50%;
  width: 40px;
  height: 40px;
  border: 1px solid ${colors.white};
`;

export const ProfilePhotoWrapper = styled.li`
  list-style-type: none;
  display: inline-block;
  position: relative;

  /* First photo moved to center */
  ${props =>
    props.position === 0
    && css`
      z-index: 1;
      transform: translateX(100%);
    `}

  /* Second photo moved to left */
  ${props =>
    props.position === 1
    && css`
      transform: translateX(-52%);
    `}

  /* Third photo moved to left */
  ${props =>
    props.position === 2
    && css`
      transform: translateX(-45%);
    `}
`;
